var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaypal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 32,
    viewBox: "0 0 56 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 31,
    rx: 5.5,
    stroke: "#DFE3E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.7791 11.0814C34.7613 11.2 34.7406 11.3212 34.7176 11.4458C33.9245 15.655 31.2107 17.1092 27.7449 17.1092H25.9803C25.5564 17.1092 25.1991 17.4272 25.1332 17.8594L23.9738 25.4605C23.9309 25.7444 24.1425 26 24.4194 26H27.5493C27.9199 26 28.2347 25.7217 28.2931 25.3439L28.3238 25.1797L28.9131 21.3144L28.951 21.1024C29.0087 20.7233 29.3243 20.4448 29.6948 20.4448H30.1629C33.1952 20.4448 35.5692 19.1724 36.263 15.49C36.5527 13.9518 36.4027 12.6673 35.6358 11.764C35.4037 11.4916 35.1158 11.2655 34.7791 11.0814Z",
    fill: "#298FC2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.949 10.7394C33.8278 10.7029 33.7028 10.6698 33.5745 10.6399C33.4456 10.6108 33.3136 10.585 33.1776 10.5623C32.7018 10.4829 32.1804 10.4452 31.622 10.4452H26.9077C26.7915 10.4452 26.6812 10.4723 26.5826 10.5213C26.3651 10.6294 26.2037 10.8421 26.1645 11.1026L25.1616 17.668L25.1328 17.8594C25.1987 17.4272 25.556 17.1092 25.9799 17.1092H27.7445C31.2103 17.1092 33.9241 15.6543 34.7172 11.4458C34.7409 11.3213 34.7609 11.2 34.7787 11.0814C34.578 10.9713 34.3607 10.8772 34.1267 10.797C34.0688 10.7771 34.0092 10.758 33.949 10.7394Z",
    fill: "#22284F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1647 11.1026C26.2039 10.8421 26.3654 10.6294 26.5829 10.5221C26.6822 10.4729 26.7918 10.4458 26.908 10.4458H31.6222C32.1806 10.4458 32.7021 10.4837 33.1778 10.5631C33.3138 10.5856 33.4458 10.6116 33.5748 10.6407C33.703 10.6704 33.828 10.7036 33.9493 10.74C34.0094 10.7586 34.0691 10.7779 34.1275 10.797C34.3615 10.8772 34.579 10.9721 34.7796 11.0814C35.0156 9.52592 34.7776 8.46683 33.964 7.50779C33.0669 6.45186 31.4478 6 29.376 6H23.3612C22.938 6 22.577 6.31801 22.5116 6.75093L20.0064 23.1642C19.957 23.4889 20.1993 23.7818 20.5161 23.7818H24.2294L26.1647 11.1026Z",
    fill: "#28356A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypal);
export default __webpack_public_path__ + "static/media/paypal.156b501ad4fbd560aab8696580ce472f.svg";
export { ForwardRef as ReactComponent };